import { render, staticRenderFns } from "./AdminClientUser.vue?vue&type=template&id=279dee5e&scoped=true&"
import script from "./AdminClientUser.vue?vue&type=script&lang=js&"
export * from "./AdminClientUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientUser.vue?vue&type=style&index=0&id=279dee5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dee5e",
  null
  
)

export default component.exports